var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleTemperatureNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_temperature_normal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(22025.174 23509.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-temperature-low",
    "data-name": "Icon awesome-temperature-low",
    d: "M11.2,4.9a4.9,4.9,0,0,0-9.8,0v7.283A6.287,6.287,0,1,0,12.6,16.1a6.242,6.242,0,0,0-1.4-3.915Z",
    transform: "translate(-22019.473 -23508.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M0,11.855A3.454,3.454,0,0,1,2.3,8.6V1.151a1.151,1.151,0,1,1,2.3,0V8.6A3.453,3.453,0,1,1,0,11.855Z",
    transform: "translate(-22016.627 -23504.438)",
    fill: "#1aad7f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleTemperatureNormal);
export default __webpack_public_path__ + "static/media/ic_tele_temperature_normal.8b304b8be5021f226772058c39aaa0d8.svg";
export { ForwardRef as ReactComponent };